var items = {
  "block.minecraft.air": "udara",
  "block.minecraft.stone": "batu",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "granit poles",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "diorit poles",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "andesit poles",
  "block.minecraft.grass_block": "balok rumput",
  "block.minecraft.dirt": "tanah",
  "block.minecraft.coarse_dirt": "tanah kasar",
  "block.minecraft.podzol": "tanah asam",
  "block.minecraft.crimson_nylium": "nilium kirmizi",
  "block.minecraft.warped_nylium": "nilium kerukut",
  "block.minecraft.cobblestone": "batu kasar",
  "block.minecraft.oak_planks": "papan ek",
  "block.minecraft.spruce_planks": "papan cemara",
  "block.minecraft.birch_planks": "papan pinus",
  "block.minecraft.jungle_planks": "papan rimba",
  "block.minecraft.acacia_planks": "papan akasia",
  "block.minecraft.dark_oak_planks": "papan ek gelap",
  "block.minecraft.crimson_planks": "papan kirmizi",
  "block.minecraft.warped_planks": "papan kerukut",
  "block.minecraft.oak_sapling": "bibit pohon ek",
  "block.minecraft.spruce_sapling": "bibit pohon cemara",
  "block.minecraft.birch_sapling": "bibit pohon pinus",
  "block.minecraft.jungle_sapling": "bibit pohon rimba",
  "block.minecraft.acacia_sapling": "bibit pohon akasia",
  "block.minecraft.dark_oak_sapling": "bibit pohon ek gelap",
  "block.minecraft.bedrock": "batu dasar",
  "block.minecraft.sand": "pasir",
  "block.minecraft.red_sand": "pasir merah",
  "block.minecraft.gravel": "kerikil",
  "block.minecraft.gold_ore": "bijih emas",
  "block.minecraft.iron_ore": "bijih besi",
  "block.minecraft.coal_ore": "bijih batu bara",
  "block.minecraft.nether_gold_ore": "bijih emas nether",
  "block.minecraft.oak_log": "gelondong ek",
  "block.minecraft.spruce_log": "gelondong cemara",
  "block.minecraft.birch_log": "gelondong pinus",
  "block.minecraft.jungle_log": "gelondong rimba",
  "block.minecraft.acacia_log": "gelondong akasia",
  "block.minecraft.dark_oak_log": "gelondong ek gelap",
  "block.minecraft.crimson_stem": "batang kirmizi",
  "block.minecraft.warped_stem": "batang kerukut",
  "block.minecraft.stripped_oak_log": "gelondong ek kupas",
  "block.minecraft.stripped_spruce_log": "gelondong cemara kupas",
  "block.minecraft.stripped_birch_log": "gelondong pinus kupas",
  "block.minecraft.stripped_jungle_log": "gelondong rimba kupas",
  "block.minecraft.stripped_acacia_log": "gelondong akasia kupas",
  "block.minecraft.stripped_dark_oak_log": "gelondong ek gelap kupas",
  "block.minecraft.stripped_crimson_stem": "batang kirmizi kupas",
  "block.minecraft.stripped_warped_stem": "batang kerukut kupas",
  "block.minecraft.stripped_oak_wood": "kayu ek kupas",
  "block.minecraft.stripped_spruce_wood": "kayu cemara kupas",
  "block.minecraft.stripped_birch_wood": "kayu pinus kupas",
  "block.minecraft.stripped_jungle_wood": "kayu rimba kupas",
  "block.minecraft.stripped_acacia_wood": "kayu akasia kupas",
  "block.minecraft.stripped_dark_oak_wood": "kayu ek gelap kupas",
  "block.minecraft.stripped_crimson_hyphae": "hifa kirmizi kupas",
  "block.minecraft.stripped_warped_hyphae": "hifa kerukut kupas",
  "block.minecraft.oak_wood": "kayu ek",
  "block.minecraft.spruce_wood": "kayu cemara",
  "block.minecraft.birch_wood": "kayu pinus",
  "block.minecraft.jungle_wood": "kayu hutan",
  "block.minecraft.acacia_wood": "kayu akasia",
  "block.minecraft.dark_oak_wood": "kayu ek gelap",
  "block.minecraft.crimson_hyphae": "hifa kirmizi",
  "block.minecraft.warped_hyphae": "hifa kerukut",
  "block.minecraft.oak_leaves": "dedaunan ek",
  "block.minecraft.spruce_leaves": "dedaunan cemara",
  "block.minecraft.birch_leaves": "dedaunan pinus",
  "block.minecraft.jungle_leaves": "dedaunan pohon rimba",
  "block.minecraft.acacia_leaves": "dedaunan akasia",
  "block.minecraft.dark_oak_leaves": "dedaunan ek gelap",
  "block.minecraft.sponge": "spons",
  "block.minecraft.wet_sponge": "spons basah",
  "block.minecraft.glass": "kaca",
  "block.minecraft.lapis_ore": "bijih lapis lazuli",
  "block.minecraft.lapis_block": "blok lapis lazuli",
  "block.minecraft.dispenser": "pelempar",
  "block.minecraft.sandstone": "batu pasir",
  "block.minecraft.chiseled_sandstone": "batu pasir pahatan",
  "block.minecraft.cut_sandstone": "potongan batu pasir",
  "block.minecraft.note_block": "kotak nada",
  "block.minecraft.powered_rail": "rel listrik",
  "block.minecraft.detector_rail": "rel detektor",
  "block.minecraft.sticky_piston": "piston lengket",
  "block.minecraft.cobweb": "benang laba-laba",
  "block.minecraft.grass": "rumput",
  "block.minecraft.fern": "pakis",
  "block.minecraft.dead_bush": "semak mati",
  "block.minecraft.seagrass": "lamun",
  "block.minecraft.sea_pickle": "acar laut",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "wol putih",
  "block.minecraft.orange_wool": "wol jingga",
  "block.minecraft.magenta_wool": "wol magenta",
  "block.minecraft.light_blue_wool": "wol biru muda",
  "block.minecraft.yellow_wool": "wol kuning",
  "block.minecraft.lime_wool": "wol limau",
  "block.minecraft.pink_wool": "wol merah jambu",
  "block.minecraft.gray_wool": "wol kelabu",
  "block.minecraft.light_gray_wool": "wol kelabu muda",
  "block.minecraft.cyan_wool": "wol sian",
  "block.minecraft.purple_wool": "wol ungu",
  "block.minecraft.blue_wool": "wol biru",
  "block.minecraft.brown_wool": "wol cokelat",
  "block.minecraft.green_wool": "wol hijau",
  "block.minecraft.red_wool": "wol merah",
  "block.minecraft.black_wool": "wol hitam",
  "block.minecraft.dandelion": "randa tapak",
  "block.minecraft.poppy": "poppy",
  "block.minecraft.blue_orchid": "anggrek biru",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "bunga liar biru",
  "block.minecraft.red_tulip": "tulip merah",
  "block.minecraft.orange_tulip": "tulip jingga",
  "block.minecraft.white_tulip": "tulip putih",
  "block.minecraft.pink_tulip": "tulip merah jambu",
  "block.minecraft.oxeye_daisy": "daisy",
  "block.minecraft.cornflower": "bunga jagung",
  "block.minecraft.lily_of_the_valley": "lili lembah",
  "block.minecraft.wither_rose": "mawar wither",
  "block.minecraft.brown_mushroom": "jamur cokelat",
  "block.minecraft.red_mushroom": "jamur merah",
  "block.minecraft.crimson_fungus": "jamur kirmizi",
  "block.minecraft.warped_fungus": "jamur kerukut",
  "block.minecraft.crimson_roots": "akar kirmizi",
  "block.minecraft.warped_roots": "akar kerukut",
  "block.minecraft.nether_sprouts": "kecambah nether",
  "block.minecraft.weeping_vines": "tanaman merambat kulai",
  "block.minecraft.twisting_vines": "tanaman merambat lilit",
  "block.minecraft.sugar_cane": "tebu",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "bambu",
  "block.minecraft.gold_block": "balok emas",
  "block.minecraft.iron_block": "balok besi",
  "block.minecraft.oak_slab": "lempeng ek",
  "block.minecraft.spruce_slab": "lempeng cemara",
  "block.minecraft.birch_slab": "lempeng pinus",
  "block.minecraft.jungle_slab": "lempeng rimba",
  "block.minecraft.acacia_slab": "lempeng akasia",
  "block.minecraft.dark_oak_slab": "lempeng ek gelap",
  "block.minecraft.crimson_slab": "lempeng kirmizi",
  "block.minecraft.warped_slab": "lempeng kerukut",
  "block.minecraft.stone_slab": "lempeng batu",
  "block.minecraft.smooth_stone_slab": "lempeng batu halus",
  "block.minecraft.sandstone_slab": "lempeng batu pasir",
  "block.minecraft.cut_sandstone_slab": "potongan lempeng batu pasir",
  "block.minecraft.petrified_oak_slab": "lempeng ek membatu",
  "block.minecraft.cobblestone_slab": "lempeng batu kasar",
  "block.minecraft.brick_slab": "lempeng bata",
  "block.minecraft.stone_brick_slab": "lempeng batu bata",
  "block.minecraft.nether_brick_slab": "lempeng bata nether",
  "block.minecraft.quartz_slab": "lempeng kuarsa",
  "block.minecraft.red_sandstone_slab": "lempeng batu pasir merah",
  "block.minecraft.cut_red_sandstone_slab": "potongan lempeng batu pasir merah",
  "block.minecraft.purpur_slab": "lempeng purpur",
  "block.minecraft.prismarine_slab": "lempeng prismarine",
  "block.minecraft.prismarine_brick_slab": "lempeng bata prismarine",
  "block.minecraft.dark_prismarine_slab": "lempeng prismarine gelap",
  "block.minecraft.smooth_quartz": "blok kuarsa halus",
  "block.minecraft.smooth_red_sandstone": "batu pasir merah halus",
  "block.minecraft.smooth_sandstone": "batu pasir halus",
  "block.minecraft.smooth_stone": "batu halus",
  "block.minecraft.bricks": "bata",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "rak buku",
  "block.minecraft.mossy_cobblestone": "batu kasar berlumut",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "obor",
  "block.minecraft.end_rod": "tongkat end",
  "block.minecraft.chorus_plant": "pohon korus",
  "block.minecraft.chorus_flower": "bunga korus",
  "block.minecraft.purpur_block": "balok purpur",
  "block.minecraft.purpur_pillar": "pilar purpur",
  "block.minecraft.purpur_stairs": "tangga purpur",
  "block.minecraft.spawner": "pemijah",
  "block.minecraft.oak_stairs": "tangga ek",
  "block.minecraft.chest": "peti",
  "block.minecraft.diamond_ore": "bijih berlian",
  "block.minecraft.diamond_block": "blok berlian",
  "block.minecraft.crafting_table": "meja kerajinan",
  "block.minecraft.farmland": "tanah garapan",
  "block.minecraft.furnace": "tungku",
  "block.minecraft.ladder": "tangga",
  "block.minecraft.rail": "rel",
  "block.minecraft.cobblestone_stairs": "tangga batu kasar",
  "block.minecraft.lever": "tuas",
  "block.minecraft.stone_pressure_plate": "papan tekan batu",
  "block.minecraft.oak_pressure_plate": "papan tekan ek",
  "block.minecraft.spruce_pressure_plate": "papan tekan cemara",
  "block.minecraft.birch_pressure_plate": "papan tekan pinus",
  "block.minecraft.jungle_pressure_plate": "papan tekan rimba",
  "block.minecraft.acacia_pressure_plate": "papan tekan akasia",
  "block.minecraft.dark_oak_pressure_plate": "papan tekan ek gelap",
  "block.minecraft.crimson_pressure_plate": "papan tekan kirmizi",
  "block.minecraft.warped_pressure_plate": "papan tekan kerukut",
  "block.minecraft.polished_blackstone_pressure_plate": "papan tekan batu hitam poles",
  "block.minecraft.redstone_ore": "bijih batu merah",
  "block.minecraft.redstone_torch": "obor batu merah",
  "block.minecraft.snow": "salju",
  "block.minecraft.ice": "es",
  "block.minecraft.snow_block": "balok salju",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "tanah liat",
  "block.minecraft.jukebox": "kotak lagu",
  "block.minecraft.oak_fence": "pagar kayu ek",
  "block.minecraft.spruce_fence": "pagar kayu cemara",
  "block.minecraft.birch_fence": "pagar kayu pinus",
  "block.minecraft.jungle_fence": "pagar kayu rimba",
  "block.minecraft.acacia_fence": "pagar kayu akasia",
  "block.minecraft.dark_oak_fence": "pagar kayu ek gelap",
  "block.minecraft.crimson_fence": "pagar kirmizi",
  "block.minecraft.warped_fence": "pagar kerukut",
  "block.minecraft.pumpkin": "labu",
  "block.minecraft.carved_pumpkin": "labu terukir",
  "block.minecraft.netherrack": "batu nether",
  "block.minecraft.soul_sand": "pasir jiwa",
  "block.minecraft.soul_soil": "tanah jiwa",
  "block.minecraft.basalt": "basal",
  "block.minecraft.polished_basalt": "basal poles",
  "block.minecraft.soul_torch": "obor jiwa",
  "block.minecraft.glowstone": "batu bersinar",
  "block.minecraft.jack_o_lantern": "lentera jack",
  "block.minecraft.oak_trapdoor": "pintu jebakan ek",
  "block.minecraft.spruce_trapdoor": "pintu jebakan cemara",
  "block.minecraft.birch_trapdoor": "pintu jebakan pinus",
  "block.minecraft.jungle_trapdoor": "pintu jebakan rimba",
  "block.minecraft.acacia_trapdoor": "pintu jebakan akasia",
  "block.minecraft.dark_oak_trapdoor": "pintu jebakan ek gelap",
  "block.minecraft.crimson_trapdoor": "pintu jebakan kirmizi",
  "block.minecraft.warped_trapdoor": "pintu jebakan kerukut",
  "block.minecraft.infested_stone": "batu terinfeksi",
  "block.minecraft.infested_cobblestone": "batu kasar terinfeksi",
  "block.minecraft.infested_stone_bricks": "batu bata terinfeksi",
  "block.minecraft.infested_mossy_stone_bricks": "batu bata berlumut terinfeksi",
  "block.minecraft.infested_cracked_stone_bricks": "bata batu retak terinfeksi",
  "block.minecraft.infested_chiseled_stone_bricks": "bata batu pahatan terinfeksi",
  "block.minecraft.stone_bricks": "batu bata",
  "block.minecraft.mossy_stone_bricks": "bata batu berlumut",
  "block.minecraft.cracked_stone_bricks": "batu bata retak",
  "block.minecraft.chiseled_stone_bricks": "bata batu pahatan",
  "block.minecraft.brown_mushroom_block": "blok jamur cokelat",
  "block.minecraft.red_mushroom_block": "blok jamur merah",
  "block.minecraft.mushroom_stem": "batang jamur",
  "block.minecraft.iron_bars": "jeruji besi",
  "block.minecraft.chain": "berantai",
  "block.minecraft.glass_pane": "panel kaca",
  "block.minecraft.melon": "semangka",
  "block.minecraft.vine": "tumbuhan merambat",
  "block.minecraft.oak_fence_gate": "pintu pagar kayu ek",
  "block.minecraft.spruce_fence_gate": "pintu pagar kayu cemara",
  "block.minecraft.birch_fence_gate": "pintu pagar kayu pinus",
  "block.minecraft.jungle_fence_gate": "pintu pagar kayu rimba",
  "block.minecraft.acacia_fence_gate": "pintu pagar kayu akasia",
  "block.minecraft.dark_oak_fence_gate": "pintu pagar kayu ek gelap",
  "block.minecraft.crimson_fence_gate": "pintu pagar kirmizi",
  "block.minecraft.warped_fence_gate": "pintu pagar kerukut",
  "block.minecraft.brick_stairs": "tangga bata",
  "block.minecraft.stone_brick_stairs": "tangga batu bata",
  "block.minecraft.mycelium": "miselium",
  "block.minecraft.lily_pad": "daun teratai",
  "block.minecraft.nether_bricks": "bata nether",
  "block.minecraft.cracked_nether_bricks": "bata nether retak",
  "block.minecraft.chiseled_nether_bricks": "bata nether pahatan",
  "block.minecraft.nether_brick_fence": "pagar batu nether",
  "block.minecraft.nether_brick_stairs": "tangga batu nether",
  "block.minecraft.enchanting_table": "meja pesona",
  "block.minecraft.end_portal_frame": "bingkai gerbang akhir",
  "block.minecraft.end_stone": "batu end",
  "block.minecraft.end_stone_bricks": "batu bata end",
  "block.minecraft.dragon_egg": "telur naga",
  "block.minecraft.redstone_lamp": "lampu batu merah",
  "block.minecraft.sandstone_stairs": "tangga batu pasir",
  "block.minecraft.emerald_ore": "bijih zamrud",
  "block.minecraft.ender_chest": "peti ender",
  "block.minecraft.tripwire_hook": "pengait kawat senggol",
  "block.minecraft.emerald_block": "blok zamrud",
  "block.minecraft.spruce_stairs": "tangga cemara",
  "block.minecraft.birch_stairs": "tangga pinus",
  "block.minecraft.jungle_stairs": "tangga rimba",
  "block.minecraft.crimson_stairs": "tangga kirmizi",
  "block.minecraft.warped_stairs": "tangga kerukut",
  "block.minecraft.command_block": "blok perintah",
  "block.minecraft.beacon": "suar",
  "block.minecraft.cobblestone_wall": "dinding batu kasar",
  "block.minecraft.mossy_cobblestone_wall": "dinding batu kasar berlumut",
  "block.minecraft.brick_wall": "dinding bata",
  "block.minecraft.prismarine_wall": "dinding prismarine",
  "block.minecraft.red_sandstone_wall": "dinding batu pasir merah",
  "block.minecraft.mossy_stone_brick_wall": "dinding batu bata berlumut",
  "block.minecraft.granite_wall": "dinding granit",
  "block.minecraft.stone_brick_wall": "dinding batu bata",
  "block.minecraft.nether_brick_wall": "dinding bata nether",
  "block.minecraft.andesite_wall": "dinding andesit",
  "block.minecraft.red_nether_brick_wall": "dinding bata nether merah",
  "block.minecraft.sandstone_wall": "dinding batu pasir",
  "block.minecraft.end_stone_brick_wall": "dinding batu bata akhir",
  "block.minecraft.diorite_wall": "dinding diorit",
  "block.minecraft.blackstone_wall": "dinding batu hitam",
  "block.minecraft.polished_blackstone_wall": "dinding batu hitam poles",
  "block.minecraft.polished_blackstone_brick_wall": "dinding bata batu hitam poles",
  "block.minecraft.stone_button": "tombol batu",
  "block.minecraft.oak_button": "tombol ek",
  "block.minecraft.spruce_button": "tombol cemara",
  "block.minecraft.birch_button": "tombol pinus",
  "block.minecraft.jungle_button": "tombol rimba",
  "block.minecraft.acacia_button": "tombol akasia",
  "block.minecraft.dark_oak_button": "tombol ek gelap",
  "block.minecraft.crimson_button": "tombol kirmizi",
  "block.minecraft.warped_button": "tombol kerukut",
  "block.minecraft.polished_blackstone_button": "tombol batu hitam poles",
  "block.minecraft.anvil": "paron",
  "block.minecraft.chipped_anvil": "paron cuil",
  "block.minecraft.damaged_anvil": "paron rusak",
  "block.minecraft.trapped_chest": "peti jebakan",
  "block.minecraft.light_weighted_pressure_plate": "papan tekan pemberat ringan",
  "block.minecraft.heavy_weighted_pressure_plate": "papan tekan pemberat berat",
  "block.minecraft.daylight_detector": "detektor cahaya",
  "block.minecraft.redstone_block": "balok batu merah",
  "block.minecraft.nether_quartz_ore": "bijih kuarsa nether",
  "block.minecraft.hopper": "corong",
  "block.minecraft.chiseled_quartz_block": "blok kuarsa pahat",
  "block.minecraft.quartz_block": "balok kuarsa",
  "block.minecraft.quartz_bricks": "bata kuarsa",
  "block.minecraft.quartz_pillar": "pilar kuarsa",
  "block.minecraft.quartz_stairs": "tangga kuarsa",
  "block.minecraft.activator_rail": "rel penyala",
  "block.minecraft.dropper": "penjatuh",
  "block.minecraft.white_terracotta": "terakota putih",
  "block.minecraft.orange_terracotta": "terakota jingga",
  "block.minecraft.magenta_terracotta": "terakota magenta",
  "block.minecraft.light_blue_terracotta": "terakota biru muda",
  "block.minecraft.yellow_terracotta": "terakota kuning",
  "block.minecraft.lime_terracotta": "terakota limau",
  "block.minecraft.pink_terracotta": "terakota merah jambu",
  "block.minecraft.gray_terracotta": "terakota kelabu",
  "block.minecraft.light_gray_terracotta": "terakota kelabu muda",
  "block.minecraft.cyan_terracotta": "terakota sian",
  "block.minecraft.purple_terracotta": "terakota ungu",
  "block.minecraft.blue_terracotta": "terakota biru",
  "block.minecraft.brown_terracotta": "terakota cokelat",
  "block.minecraft.green_terracotta": "terakota hijau",
  "block.minecraft.red_terracotta": "terakota merah",
  "block.minecraft.black_terracotta": "terakota hitam",
  "block.minecraft.barrier": "penghalang",
  "block.minecraft.iron_trapdoor": "pintu jebakan besi",
  "block.minecraft.hay_block": "jerami",
  "block.minecraft.white_carpet": "karpet putih",
  "block.minecraft.orange_carpet": "karpet jinnga",
  "block.minecraft.magenta_carpet": "karpet magenta",
  "block.minecraft.light_blue_carpet": "karpet biru muda",
  "block.minecraft.yellow_carpet": "karpet kuning",
  "block.minecraft.lime_carpet": "karpet limau",
  "block.minecraft.pink_carpet": "karpet merah jambu",
  "block.minecraft.gray_carpet": "karpet kelabu",
  "block.minecraft.light_gray_carpet": "karpet kelabu muda",
  "block.minecraft.cyan_carpet": "karpet sian",
  "block.minecraft.purple_carpet": "karpet ungu",
  "block.minecraft.blue_carpet": "karpet biru",
  "block.minecraft.brown_carpet": "karpet coklat",
  "block.minecraft.green_carpet": "karpet hijau",
  "block.minecraft.red_carpet": "karpet merah",
  "block.minecraft.black_carpet": "karpet hitam",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "blok batu bara",
  "block.minecraft.packed_ice": "es batu",
  "block.minecraft.acacia_stairs": "tangga akasia",
  "block.minecraft.dark_oak_stairs": "tangga ek gelap",
  "block.minecraft.slime_block": "balok geladir",
  "block.minecraft.grass_path": "jalan berumput",
  "block.minecraft.sunflower": "bunga matahari",
  "block.minecraft.lilac": "lilac",
  "block.minecraft.rose_bush": "semak mawar",
  "block.minecraft.peony": "peony",
  "block.minecraft.tall_grass": "rumput tinggi",
  "block.minecraft.large_fern": "pakis besar",
  "block.minecraft.white_stained_glass": "kaca patri putih",
  "block.minecraft.orange_stained_glass": "kaca patri jingga",
  "block.minecraft.magenta_stained_glass": "kaca patri magenta",
  "block.minecraft.light_blue_stained_glass": "kaca patri biru muda",
  "block.minecraft.yellow_stained_glass": "kaca patri kuning",
  "block.minecraft.lime_stained_glass": "kaca patri limau",
  "block.minecraft.pink_stained_glass": "kaca patri merah jambu",
  "block.minecraft.gray_stained_glass": "kaca berwarna kelabu",
  "block.minecraft.light_gray_stained_glass": "kaca berwarna kelabu muda",
  "block.minecraft.cyan_stained_glass": "kaca patri sian",
  "block.minecraft.purple_stained_glass": "kaca patri ungu",
  "block.minecraft.blue_stained_glass": "kaca patri biru",
  "block.minecraft.brown_stained_glass": "kaca patri cokelat",
  "block.minecraft.green_stained_glass": "kaca patri hijau",
  "block.minecraft.red_stained_glass": "kaca patri merah",
  "block.minecraft.black_stained_glass": "kaca patri hitam",
  "block.minecraft.white_stained_glass_pane": "panel kaca patri putih",
  "block.minecraft.orange_stained_glass_pane": "panel kaca patri jingga",
  "block.minecraft.magenta_stained_glass_pane": "panel kaca patri magenta",
  "block.minecraft.light_blue_stained_glass_pane": "panel kaca patri biru muda",
  "block.minecraft.yellow_stained_glass_pane": "panel kaca patri kuning",
  "block.minecraft.lime_stained_glass_pane": "panel kaca patri limau",
  "block.minecraft.pink_stained_glass_pane": "panel kaca patri merah jambu",
  "block.minecraft.gray_stained_glass_pane": "panel kaca patri kelabu",
  "block.minecraft.light_gray_stained_glass_pane": "panel kaca patri kelabu muda",
  "block.minecraft.cyan_stained_glass_pane": "panel kaca patri sian",
  "block.minecraft.purple_stained_glass_pane": "panel kaca patri ungu",
  "block.minecraft.blue_stained_glass_pane": "panel kaca patri biru",
  "block.minecraft.brown_stained_glass_pane": "panel kaca patri cokelat",
  "block.minecraft.green_stained_glass_pane": "panel kaca patri hijau",
  "block.minecraft.red_stained_glass_pane": "panel kaca patri merah",
  "block.minecraft.black_stained_glass_pane": "panel kaca patri hitam",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_bricks": "batu bata prismarine",
  "block.minecraft.dark_prismarine": "prismarine gelap",
  "block.minecraft.prismarine_stairs": "tangga prismarine",
  "block.minecraft.prismarine_brick_stairs": "tangga bata prismarine",
  "block.minecraft.dark_prismarine_stairs": "tangga prismarine gelap",
  "block.minecraft.sea_lantern": "lentera laut",
  "block.minecraft.red_sandstone": "batu pasir merah",
  "block.minecraft.chiseled_red_sandstone": "batu pasir merah pahatan",
  "block.minecraft.cut_red_sandstone": "potongan batu pasir merah",
  "block.minecraft.red_sandstone_stairs": "tangga batu pasir merah",
  "block.minecraft.repeating_command_block": "pengulang blok perintah",
  "block.minecraft.chain_command_block": "blok perintah berantai",
  "block.minecraft.magma_block": "blok magma",
  "block.minecraft.nether_wart_block": "blok ketuat nether",
  "block.minecraft.warped_wart_block": "blok ketuat kerukut",
  "block.minecraft.red_nether_bricks": "bata nether merah",
  "block.minecraft.bone_block": "balok tulang",
  "block.minecraft.structure_void": "struktur hampa",
  "block.minecraft.observer": "pengamat",
  "block.minecraft.shulker_box": "kotak periuk pengintai",
  "block.minecraft.white_shulker_box": "kotak periuk pengintai putih",
  "block.minecraft.orange_shulker_box": "kotak periuk pengintai jingga",
  "block.minecraft.magenta_shulker_box": "kotak periuk pengintai magenta",
  "block.minecraft.light_blue_shulker_box": "kotak periuk pengintai biru muda",
  "block.minecraft.yellow_shulker_box": "periuk pengintai kuning",
  "block.minecraft.lime_shulker_box": "kotak periuk pengintai limau",
  "block.minecraft.pink_shulker_box": "kotak periuk pengintai merah jambu",
  "block.minecraft.gray_shulker_box": "kotak periuk pengintai kelabu",
  "block.minecraft.light_gray_shulker_box": "kotak periuk pengintai kelabu muda",
  "block.minecraft.cyan_shulker_box": "kotak periuk pengintai sian",
  "block.minecraft.purple_shulker_box": "kotak periuk pengintai ungu",
  "block.minecraft.blue_shulker_box": "kotak periuk pengintai biru",
  "block.minecraft.brown_shulker_box": "kotak periuk pengintai coklat",
  "block.minecraft.green_shulker_box": "kotak periuk pengintai hijau",
  "block.minecraft.red_shulker_box": "kotak periuk pengintai merah",
  "block.minecraft.black_shulker_box": "kotak periuk pengintai hitam",
  "block.minecraft.white_glazed_terracotta": "terakota berglasir putih",
  "block.minecraft.orange_glazed_terracotta": "terakota berglasir jingga",
  "block.minecraft.magenta_glazed_terracotta": "terakota berglasir magenta",
  "block.minecraft.light_blue_glazed_terracotta": "terakota berglasir biru muda",
  "block.minecraft.yellow_glazed_terracotta": "terakota berglasir kuning",
  "block.minecraft.lime_glazed_terracotta": "terakota berglasir limau",
  "block.minecraft.pink_glazed_terracotta": "terakota berglasir merah jambu",
  "block.minecraft.gray_glazed_terracotta": "terakota berglasir kelabu",
  "block.minecraft.light_gray_glazed_terracotta": "terakota berglasir kelabu muda",
  "block.minecraft.cyan_glazed_terracotta": "terakota berglasir sian",
  "block.minecraft.purple_glazed_terracotta": "terakota berglasir ungu",
  "block.minecraft.blue_glazed_terracotta": "terakota berglasir biru",
  "block.minecraft.brown_glazed_terracotta": "terakota berglasir cokelat",
  "block.minecraft.green_glazed_terracotta": "terakota berglasir hijau",
  "block.minecraft.red_glazed_terracotta": "terakota berglasir merah",
  "block.minecraft.black_glazed_terracotta": "terakota berglasir hitam",
  "block.minecraft.white_concrete": "beton putih",
  "block.minecraft.orange_concrete": "beton jingga",
  "block.minecraft.magenta_concrete": "beton magenta",
  "block.minecraft.light_blue_concrete": "beton biru muda",
  "block.minecraft.yellow_concrete": "beton kuning",
  "block.minecraft.lime_concrete": "beton limau",
  "block.minecraft.pink_concrete": "beton merah jambu",
  "block.minecraft.gray_concrete": "beton kelabu",
  "block.minecraft.light_gray_concrete": "beton kelabu muda",
  "block.minecraft.cyan_concrete": "beton sian",
  "block.minecraft.purple_concrete": "beton ungu",
  "block.minecraft.blue_concrete": "beton biru",
  "block.minecraft.brown_concrete": "beton cokelat",
  "block.minecraft.green_concrete": "beton hijau",
  "block.minecraft.red_concrete": "beton merah",
  "block.minecraft.black_concrete": "beton hitam",
  "block.minecraft.white_concrete_powder": "semen putih",
  "block.minecraft.orange_concrete_powder": "semen jingga",
  "block.minecraft.magenta_concrete_powder": "semen magenta",
  "block.minecraft.light_blue_concrete_powder": "semen biru muda",
  "block.minecraft.yellow_concrete_powder": "semen kuning",
  "block.minecraft.lime_concrete_powder": "semen limau",
  "block.minecraft.pink_concrete_powder": "semen merah jambu",
  "block.minecraft.gray_concrete_powder": "semen kelabu",
  "block.minecraft.light_gray_concrete_powder": "semen kelabu muda",
  "block.minecraft.cyan_concrete_powder": "semen sian",
  "block.minecraft.purple_concrete_powder": "semen ungu",
  "block.minecraft.blue_concrete_powder": "semen biru",
  "block.minecraft.brown_concrete_powder": "semen cokelat",
  "block.minecraft.green_concrete_powder": "semen hijau",
  "block.minecraft.red_concrete_powder": "semen merah",
  "block.minecraft.black_concrete_powder": "semen hitam",
  "block.minecraft.turtle_egg": "telur penyu",
  "block.minecraft.dead_tube_coral_block": "blok karang pipa mati",
  "block.minecraft.dead_brain_coral_block": "blok karang otak mati",
  "block.minecraft.dead_bubble_coral_block": "blok karang gelembung mati",
  "block.minecraft.dead_fire_coral_block": "blok karang api mati",
  "block.minecraft.dead_horn_coral_block": "blok karang tanduk mati",
  "block.minecraft.tube_coral_block": "blok karang pipa",
  "block.minecraft.brain_coral_block": "blok karang otak",
  "block.minecraft.bubble_coral_block": "blok karang gelembung",
  "block.minecraft.fire_coral_block": "blok karang api",
  "block.minecraft.horn_coral_block": "blok karang tanduk",
  "block.minecraft.tube_coral": "karang pipa",
  "block.minecraft.brain_coral": "karang otak",
  "block.minecraft.bubble_coral": "karang gelembung",
  "block.minecraft.fire_coral": "karang api",
  "block.minecraft.horn_coral": "karang tanduk",
  "block.minecraft.dead_brain_coral": "karang otak mati",
  "block.minecraft.dead_bubble_coral": "karang gelembung mati",
  "block.minecraft.dead_fire_coral": "karang api mati",
  "block.minecraft.dead_horn_coral": "karang tanduk mati",
  "block.minecraft.dead_tube_coral": "karang pipa mati",
  "block.minecraft.tube_coral_fan": "kipas laut pipa",
  "block.minecraft.brain_coral_fan": "kipas laut otak",
  "block.minecraft.bubble_coral_fan": "kipas laut gelembung",
  "block.minecraft.fire_coral_fan": "kipas laut api",
  "block.minecraft.horn_coral_fan": "kipas laut tanduk",
  "block.minecraft.dead_tube_coral_fan": "kipas laut pipa mati",
  "block.minecraft.dead_brain_coral_fan": "kipas laut otak mati",
  "block.minecraft.dead_bubble_coral_fan": "kipas laut gelembung mati",
  "block.minecraft.dead_fire_coral_fan": "kipas laut api mati",
  "block.minecraft.dead_horn_coral_fan": "kipas laut tanduk mati",
  "block.minecraft.blue_ice": "es biru",
  "block.minecraft.conduit": "talang salur",
  "block.minecraft.polished_granite_stairs": "tangga granit poles",
  "block.minecraft.smooth_red_sandstone_stairs": "tangga batu pasir merah halus",
  "block.minecraft.mossy_stone_brick_stairs": "tangga batu bata berlumut",
  "block.minecraft.polished_diorite_stairs": "tangga diorit poles",
  "block.minecraft.mossy_cobblestone_stairs": "tangga batu kasar berlumut",
  "block.minecraft.end_stone_brick_stairs": "tangga batu bata akhir",
  "block.minecraft.stone_stairs": "tangga batu",
  "block.minecraft.smooth_sandstone_stairs": "tangga batu pasir halus",
  "block.minecraft.smooth_quartz_stairs": "tangga kuarsa halus",
  "block.minecraft.granite_stairs": "tangga granit",
  "block.minecraft.andesite_stairs": "tangga andesit",
  "block.minecraft.red_nether_brick_stairs": "tangga bata nether merah",
  "block.minecraft.polished_andesite_stairs": "tangga andesit poles",
  "block.minecraft.diorite_stairs": "tangga diorit",
  "block.minecraft.polished_granite_slab": "lempeng granit poles",
  "block.minecraft.smooth_red_sandstone_slab": "lempeng batu pasir merah halus",
  "block.minecraft.mossy_stone_brick_slab": "lempeng batu bata berlumut",
  "block.minecraft.polished_diorite_slab": "lempeng diorit poles",
  "block.minecraft.mossy_cobblestone_slab": "lempeng batu kasar berlumut",
  "block.minecraft.end_stone_brick_slab": "lempeng batu bata akhir",
  "block.minecraft.smooth_sandstone_slab": "lempeng batu pasir halus",
  "block.minecraft.smooth_quartz_slab": "lempeng kuarsa halus",
  "block.minecraft.granite_slab": "lempeng granit",
  "block.minecraft.andesite_slab": "lempeng andesit",
  "block.minecraft.red_nether_brick_slab": "lempeng bata nether merah",
  "block.minecraft.polished_andesite_slab": "lempeng andesit poles",
  "block.minecraft.diorite_slab": "lempeng diorit",
  "block.minecraft.scaffolding": "perancah",
  "block.minecraft.iron_door": "pintu besi",
  "block.minecraft.oak_door": "pintu kayu ek",
  "block.minecraft.spruce_door": "pintu kayu cemara",
  "block.minecraft.birch_door": "pintu kayu pinus",
  "block.minecraft.jungle_door": "pintu kayu rimba",
  "block.minecraft.acacia_door": "pintu kayu akasia",
  "block.minecraft.dark_oak_door": "pintu kayu ek gelap",
  "block.minecraft.crimson_door": "pintu kirmizi",
  "block.minecraft.warped_door": "pintu kerukut",
  "block.minecraft.repeater": "pengulang batu merah",
  "block.minecraft.comparator": "pembanding batu merah",
  "block.minecraft.structure_block": "blok struktur",
  "block.minecraft.jigsaw": "blok gergaji ukir",
  "item.minecraft.turtle_helmet": "cangkang penyu□□saat di kepala:□+2 zirah",
  "item.minecraft.scute": "skat",
  "item.minecraft.iron_shovel": "sekop besi□□saat di tangan utama:□+3.5 kekuatan serangan□-3 kecepatan serangan",
  "item.minecraft.iron_pickaxe": "beliung besi□□saat di tangan utama:□+3 kekuatan serangan□-2.8 kecepatan serangan",
  "item.minecraft.iron_axe": "kapak besi□□saat di tangan utama:□+8 kekuatan serangan□-3.1 kecepatan serangan",
  "item.minecraft.flint_and_steel": "pemantik api",
  "item.minecraft.apple": "apel",
  "item.minecraft.bow": "busur",
  "item.minecraft.arrow": "panah",
  "item.minecraft.coal": "batu bara",
  "item.minecraft.charcoal": "arang",
  "item.minecraft.diamond": "berlian",
  "item.minecraft.iron_ingot": "batangan besi",
  "item.minecraft.gold_ingot": "batangan emas",
  "item.minecraft.netherite_ingot": "batangan neterit",
  "item.minecraft.netherite_scrap": "kepingan neterit",
  "item.minecraft.iron_sword": "pedang besi□□saat di tangan utama:□+5 kekuatan serangan□-2.4 kecepatan serangan",
  "item.minecraft.wooden_sword": "pedang kayu□□saat di tangan utama:□+3 kekuatan serangan□-2.4 kecepatan serangan",
  "item.minecraft.wooden_shovel": "sekop kayu□□saat di tangan utama:□+1.5 kekuatan serangan□-3 kecepatan serangan",
  "item.minecraft.wooden_pickaxe": "beliung kayu□□saat di tangan utama:□+1 kekuatan serangan□-2.8 kecepatan serangan",
  "item.minecraft.wooden_axe": "kapak kayu□□saat di tangan utama:□+6 kekuatan serangan□-3.2 kecepatan serangan",
  "item.minecraft.stone_sword": "pedang batu□□saat di tangan utama:□+4 kekuatan serangan□-2.4 kecepatan serangan",
  "item.minecraft.stone_shovel": "sekop batu□□saat di tangan utama:□+2.5 kekuatan serangan□-3 kecepatan serangan",
  "item.minecraft.stone_pickaxe": "beliung batu□□saat di tangan utama:□+2 kekuatan serangan□-2.8 kecepatan serangan",
  "item.minecraft.stone_axe": "kapak batu□□saat di tangan utama:□+8 kekuatan serangan□-3.2 kecepatan serangan",
  "item.minecraft.diamond_sword": "pedang berlian□□saat di tangan utama:□+6 kekuatan serangan□-2.4 kecepatan serangan",
  "item.minecraft.diamond_shovel": "sekop berlian□□saat di tangan utama:□+4.5 kekuatan serangan□-3 kecepatan serangan",
  "item.minecraft.diamond_pickaxe": "beliung berlian□□saat di tangan utama:□+4 kekuatan serangan□-2.8 kecepatan serangan",
  "item.minecraft.diamond_axe": "kapak berlian□□saat di tangan utama:□+8 kekuatan serangan□-3 kecepatan serangan",
  "item.minecraft.stick": "batang kayu",
  "item.minecraft.bowl": "mangkuk",
  "item.minecraft.mushroom_stew": "sup jamur",
  "item.minecraft.golden_sword": "pedang emas□□saat di tangan utama:□+3 kekuatan serangan□-2.4 kecepatan serangan",
  "item.minecraft.golden_shovel": "sekop emas□□saat di tangan utama:□+1.5 kekuatan serangan□-3 kecepatan serangan",
  "item.minecraft.golden_pickaxe": "beliung emas□□saat di tangan utama:□+1 kekuatan serangan□-2.8 kecepatan serangan",
  "item.minecraft.golden_axe": "kapak emas□□saat di tangan utama:□+6 kekuatan serangan□-3 kecepatan serangan",
  "item.minecraft.netherite_sword": "pedang neterit□□saat di tangan utama:□+7 kekuatan serangan□-2.4 kecepatan serangan",
  "item.minecraft.netherite_shovel": "sekop neterit□□saat di tangan utama:□+5.5 kekuatan serangan□-3 kecepatan serangan",
  "item.minecraft.netherite_pickaxe": "beliung neterit□□saat di tangan utama:□+5 kekuatan serangan□-2.8 kecepatan serangan",
  "item.minecraft.netherite_axe": "kapak neterit□□saat di tangan utama:□+9 kekuatan serangan□-3 kecepatan serangan",
  "item.minecraft.string": "benang",
  "item.minecraft.feather": "bulu",
  "item.minecraft.gunpowder": "bubuk mesiu",
  "item.minecraft.wooden_hoe": "cangkul kayu□□saat di tangan utama:□-3 kecepatan serangan",
  "item.minecraft.stone_hoe": "cangkul batu□□saat di tangan utama:□-2 kecepatan serangan",
  "item.minecraft.iron_hoe": "cangkul besi□□saat di tangan utama:□-1 kecepatan serangan",
  "item.minecraft.diamond_hoe": "cangkul berlian□□saat di tangan utama:",
  "item.minecraft.golden_hoe": "cangkul emas□□saat di tangan utama:□-3 kecepatan serangan",
  "item.minecraft.netherite_hoe": "cangkul neterit□□saat di tangan utama:",
  "item.minecraft.wheat_seeds": "benih gandum",
  "item.minecraft.wheat": "gandum",
  "item.minecraft.bread": "roti",
  "item.minecraft.leather_helmet": "topi kulit□□saat di kepala:□+1 zirah",
  "item.minecraft.leather_chestplate": "jubah kulit□□saat di badan:□+3 zirah",
  "item.minecraft.leather_leggings": "celana kulit□□saat digunakan di kaki:□+2 zirah",
  "item.minecraft.leather_boots": "sepatu kulit□□saat di kaki:□+1 zirah",
  "item.minecraft.chainmail_helmet": "helm rantai□□saat di kepala:□+2 zirah",
  "item.minecraft.chainmail_chestplate": "baju rantai□□saat di badan:□+5 zirah",
  "item.minecraft.chainmail_leggings": "celana rantai□□saat digunakan di kaki:□+4 zirah",
  "item.minecraft.chainmail_boots": "sepatu rantai□□saat di kaki:□+1 zirah",
  "item.minecraft.iron_helmet": "helm besi□□saat di kepala:□+2 zirah",
  "item.minecraft.iron_chestplate": "baju besi□□saat di badan:□+6 zirah",
  "item.minecraft.iron_leggings": "celana besi□□saat digunakan di kaki:□+5 zirah",
  "item.minecraft.iron_boots": "sepatu besi□□saat di kaki:□+2 zirah",
  "item.minecraft.diamond_helmet": "helm berlian□□saat di kepala:□+3 zirah□+2 ketangguhan zirah",
  "item.minecraft.diamond_chestplate": "baju berlian□□saat di badan:□+8 zirah□+2 ketangguhan zirah",
  "item.minecraft.diamond_leggings": "celana berlian□□saat digunakan di kaki:□+6 zirah□+2 ketangguhan zirah",
  "item.minecraft.diamond_boots": "sepatu berlian□□saat di kaki:□+3 zirah□+2 ketangguhan zirah",
  "item.minecraft.golden_helmet": "helm emas□□saat di kepala:□+2 zirah",
  "item.minecraft.golden_chestplate": "baju emas□□saat di badan:□+5 zirah",
  "item.minecraft.golden_leggings": "celana emas□□saat digunakan di kaki:□+3 zirah",
  "item.minecraft.golden_boots": "sepatu emas□□saat di kaki:□+1 zirah",
  "item.minecraft.netherite_helmet": "helm neterit□□saat di kepala:□+3 zirah□+3 ketangguhan zirah□+1 ketahanan pukul mundur",
  "item.minecraft.netherite_chestplate": "baju neterit□□saat di badan:□+8 zirah□+3 ketangguhan zirah□+1 ketahanan pukul mundur",
  "item.minecraft.netherite_leggings": "celana neterit□□saat digunakan di kaki:□+6 zirah□+3 ketangguhan zirah□+1 ketahanan pukul mundur",
  "item.minecraft.netherite_boots": "sepatu neterit□□saat di kaki:□+3 zirah□+3 ketangguhan zirah□+1 ketahanan pukul mundur",
  "item.minecraft.flint": "batu api",
  "item.minecraft.porkchop": "daging babi mentah",
  "item.minecraft.cooked_porkchop": "daging babi matang",
  "item.minecraft.painting": "lukisan",
  "item.minecraft.golden_apple": "apel emas",
  "item.minecraft.enchanted_golden_apple": "apel emas berpesona",
  "block.minecraft.oak_sign": "penanda ek",
  "block.minecraft.spruce_sign": "penanda cemara",
  "block.minecraft.birch_sign": "penanda pinus",
  "block.minecraft.jungle_sign": "penanda rimba",
  "block.minecraft.acacia_sign": "penanda akasia",
  "block.minecraft.dark_oak_sign": "penanda ek gelap",
  "block.minecraft.crimson_sign": "penanda kirmizi",
  "block.minecraft.warped_sign": "penanda kerukut",
  "item.minecraft.bucket": "ember",
  "item.minecraft.water_bucket": "ember air",
  "item.minecraft.lava_bucket": "ember lava",
  "item.minecraft.minecart": "kereta tambang",
  "item.minecraft.saddle": "pelana",
  "item.minecraft.redstone": "serbuk batu merah",
  "item.minecraft.snowball": "bola salju",
  "item.minecraft.oak_boat": "perahu kayu ek",
  "item.minecraft.leather": "kulit",
  "item.minecraft.milk_bucket": "ember susu",
  "item.minecraft.pufferfish_bucket": "ember ikan buntal",
  "item.minecraft.salmon_bucket": "ember salem",
  "item.minecraft.cod_bucket": "ember kod",
  "item.minecraft.tropical_fish_bucket": "ember ikan tropis",
  "item.minecraft.brick": "bata",
  "item.minecraft.clay_ball": "bola tanah liat",
  "block.minecraft.dried_kelp_block": "balok kelp kering",
  "item.minecraft.paper": "kertas",
  "item.minecraft.book": "buku",
  "item.minecraft.slime_ball": "bola geladir",
  "item.minecraft.chest_minecart": "kereta tambang dengan peti",
  "item.minecraft.furnace_minecart": "kereta tambang bertungku",
  "item.minecraft.egg": "telur",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "tongkat pancing",
  "item.minecraft.clock": "jam",
  "item.minecraft.glowstone_dust": "debu batu bersinar",
  "item.minecraft.cod": "kod mentah",
  "item.minecraft.salmon": "salem mentah",
  "item.minecraft.tropical_fish": "ikan tropis",
  "item.minecraft.pufferfish": "ikan buntal",
  "item.minecraft.cooked_cod": "kod matang",
  "item.minecraft.cooked_salmon": "salem matang",
  "item.minecraft.ink_sac": "kantong tinta",
  "item.minecraft.red_dye": "pewarna merah",
  "item.minecraft.green_dye": "pewarna hijau",
  "item.minecraft.cocoa_beans": "biji kakao",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "pewarna ungu",
  "item.minecraft.cyan_dye": "pewarna sian",
  "item.minecraft.light_gray_dye": "pewarna kelabu muda",
  "item.minecraft.gray_dye": "pewarna kelabu",
  "item.minecraft.pink_dye": "pewarna merah jambu",
  "item.minecraft.lime_dye": "pewarna limau",
  "item.minecraft.yellow_dye": "pewarna kuning",
  "item.minecraft.light_blue_dye": "pewarna biru muda",
  "item.minecraft.magenta_dye": "pewarna magenta",
  "item.minecraft.orange_dye": "pewarna jingga",
  "item.minecraft.bone_meal": "tepung tulang",
  "item.minecraft.blue_dye": "pewarna biru",
  "item.minecraft.brown_dye": "pewarna cokelat",
  "item.minecraft.black_dye": "pewarna hitam",
  "item.minecraft.white_dye": "pewarna putih",
  "item.minecraft.bone": "tulang",
  "item.minecraft.sugar": "gula",
  "block.minecraft.cake": "kue",
  "block.minecraft.white_bed": "tempat tidur putih",
  "block.minecraft.orange_bed": "tempat tidur jingga",
  "block.minecraft.magenta_bed": "tempat tidur magenta",
  "block.minecraft.light_blue_bed": "tempat tidur biru muda",
  "block.minecraft.yellow_bed": "tempat tidur kuning",
  "block.minecraft.lime_bed": "tempat tidur limau",
  "block.minecraft.pink_bed": "tempat tidur merah jambu",
  "block.minecraft.gray_bed": "tempat tidur kelabu",
  "block.minecraft.light_gray_bed": "tempat tidur kelabu muda",
  "block.minecraft.cyan_bed": "tempat tidur sian",
  "block.minecraft.purple_bed": "tempat tidur ungu",
  "block.minecraft.blue_bed": "tempat tidur biru",
  "block.minecraft.brown_bed": "tempat tidur cokelat",
  "block.minecraft.green_bed": "tempat tidur hijau",
  "block.minecraft.red_bed": "tempat tidur merah",
  "block.minecraft.black_bed": "tempat tidur hitam",
  "item.minecraft.cookie": "biskuit",
  "item.minecraft.filled_map": "peta□#0",
  "item.minecraft.shears": "gunting",
  "item.minecraft.melon_slice": "irisan semangka",
  "item.minecraft.dried_kelp": "kelp kering",
  "item.minecraft.pumpkin_seeds": "biji labu",
  "item.minecraft.melon_seeds": "biji semangka",
  "item.minecraft.beef": "daging sapi mentah",
  "item.minecraft.cooked_beef": "daging panggang",
  "item.minecraft.chicken": "daging ayam mentah",
  "item.minecraft.cooked_chicken": "daging ayam bakar",
  "item.minecraft.rotten_flesh": "daging busuk",
  "item.minecraft.ender_pearl": "permata ender",
  "item.minecraft.blaze_rod": "tongkat kemamang",
  "item.minecraft.ghast_tear": "air mata hantu nether",
  "item.minecraft.gold_nugget": "bongkahan emas",
  "item.minecraft.nether_wart": "ketuat nether",
  "item.minecraft.potion": "ramuan tak bisa dibuat□tanpa efek",
  "item.minecraft.glass_bottle": "botol kaca",
  "item.minecraft.spider_eye": "mata laba-laba",
  "item.minecraft.fermented_spider_eye": "mata laba-laba beragi",
  "item.minecraft.blaze_powder": "bubuk kemamang",
  "item.minecraft.magma_cream": "krim magma",
  "block.minecraft.brewing_stand": "alat peramu",
  "block.minecraft.cauldron": "kuali",
  "item.minecraft.ender_eye": "mata ender",
  "item.minecraft.glistering_melon_slice": "semangka emas",
  "item.minecraft.bat_spawn_egg": "telur pijah kelelawar",
  "item.minecraft.bee_spawn_egg": "telur pijah lebah",
  "item.minecraft.blaze_spawn_egg": "telur pijah kemamang",
  "item.minecraft.cat_spawn_egg": "telur pijah kucing",
  "item.minecraft.cave_spider_spawn_egg": "telur pijah laba-laba gua",
  "item.minecraft.chicken_spawn_egg": "telur pijah ayam",
  "item.minecraft.cod_spawn_egg": "telur pijah kod",
  "item.minecraft.cow_spawn_egg": "telur pijah sapi",
  "item.minecraft.creeper_spawn_egg": "telur pijah creeper",
  "item.minecraft.dolphin_spawn_egg": "telur pijah lumba-lumba",
  "item.minecraft.donkey_spawn_egg": "telur pijah keledai",
  "item.minecraft.drowned_spawn_egg": "telur pijah zombi air",
  "item.minecraft.elder_guardian_spawn_egg": "telur pijah pamong tetua",
  "item.minecraft.enderman_spawn_egg": "telur pijah enderman",
  "item.minecraft.endermite_spawn_egg": "telur pijah tungau ender",
  "item.minecraft.evoker_spawn_egg": "telur pijah dukun",
  "item.minecraft.fox_spawn_egg": "telur pijah rubah",
  "item.minecraft.ghast_spawn_egg": "telur pijah hantu nether",
  "item.minecraft.guardian_spawn_egg": "telur pijah pamong",
  "item.minecraft.hoglin_spawn_egg": "telur pijah hoglin",
  "item.minecraft.horse_spawn_egg": "telur pijah kuda",
  "item.minecraft.husk_spawn_egg": "telur pijah zombi kering",
  "item.minecraft.llama_spawn_egg": "telur pijah llama",
  "item.minecraft.magma_cube_spawn_egg": "telur pijah kubus magma",
  "item.minecraft.mooshroom_spawn_egg": "telur pijah sapi jamur",
  "item.minecraft.mule_spawn_egg": "telur pijah bagal",
  "item.minecraft.ocelot_spawn_egg": "telur pijah kucing hutan",
  "item.minecraft.panda_spawn_egg": "telur pijah panda",
  "item.minecraft.parrot_spawn_egg": "telur pijah beo",
  "item.minecraft.phantom_spawn_egg": "telur pijah pari momok",
  "item.minecraft.pig_spawn_egg": "telur pijah babi",
  "item.minecraft.piglin_spawn_egg": "telur pijah piglin",
  "item.minecraft.pillager_spawn_egg": "telur pijah penjarah",
  "item.minecraft.polar_bear_spawn_egg": "telur pijah beruang kutub",
  "item.minecraft.pufferfish_spawn_egg": "telur pijah ikan buntal",
  "item.minecraft.rabbit_spawn_egg": "telur pijah kelinci",
  "item.minecraft.ravager_spawn_egg": "telur pijah setan penjarah",
  "item.minecraft.salmon_spawn_egg": "telur pijah salem",
  "item.minecraft.sheep_spawn_egg": "telur pijah domba",
  "item.minecraft.shulker_spawn_egg": "telur pijah periuk pengintai",
  "item.minecraft.silverfish_spawn_egg": "telur pijah gegat",
  "item.minecraft.skeleton_spawn_egg": "telur pijah bengkarak",
  "item.minecraft.skeleton_horse_spawn_egg": "telur pijah kuda bengkarak",
  "item.minecraft.slime_spawn_egg": "telur pijah geladir",
  "item.minecraft.spider_spawn_egg": "telur pijah laba-laba",
  "item.minecraft.squid_spawn_egg": "telur pijah cumi-cumi",
  "item.minecraft.stray_spawn_egg": "telur pijah bengkarak salju",
  "item.minecraft.strider_spawn_egg": "telur pijah pejalan",
  "item.minecraft.trader_llama_spawn_egg": "telur pijah llama pedagang",
  "item.minecraft.tropical_fish_spawn_egg": "telur pijah ikan tropis",
  "item.minecraft.turtle_spawn_egg": "telur pijah penyu",
  "item.minecraft.vex_spawn_egg": "telur pijah arwah",
  "item.minecraft.villager_spawn_egg": "telur pijah penduduk",
  "item.minecraft.vindicator_spawn_egg": "telur pijah penganut",
  "item.minecraft.wandering_trader_spawn_egg": "telur pijah pedagang keliling",
  "item.minecraft.witch_spawn_egg": "telur pijah penyihir",
  "item.minecraft.wither_skeleton_spawn_egg": "telur pijah bengkarak alum",
  "item.minecraft.wolf_spawn_egg": "telur pijah serigala",
  "item.minecraft.zoglin_spawn_egg": "telur pijah zoglin",
  "item.minecraft.zombie_spawn_egg": "telur pijah zombi",
  "item.minecraft.zombie_horse_spawn_egg": "telur pijah kuda zombi",
  "item.minecraft.zombie_villager_spawn_egg": "telur pijah zombi penduduk",
  "item.minecraft.zombified_piglin_spawn_egg": "telur pijah zombi piglin",
  "item.minecraft.experience_bottle": "botol pesona",
  "item.minecraft.fire_charge": "bola api",
  "item.minecraft.writable_book": "buku dan pena",
  "item.minecraft.written_book": "buku dengan tulisan",
  "item.minecraft.emerald": "zamrud",
  "item.minecraft.item_frame": "bingkai benda",
  "block.minecraft.flower_pot": "pot bunga",
  "item.minecraft.carrot": "wortel",
  "item.minecraft.potato": "kentang",
  "item.minecraft.baked_potato": "kentang panggang",
  "item.minecraft.poisonous_potato": "kentang beracun",
  "item.minecraft.map": "peta kosong",
  "item.minecraft.golden_carrot": "wortel emas",
  "block.minecraft.skeleton_skull": "tengkorak bengkarak",
  "block.minecraft.wither_skeleton_skull": "tengkorak bengkarak alum",
  "block.minecraft.player_head": "kepala pemain",
  "block.minecraft.zombie_head": "kepala zombi",
  "block.minecraft.creeper_head": "kepala creeper",
  "block.minecraft.dragon_head": "kepala naga",
  "item.minecraft.carrot_on_a_stick": "wortel di tongkat",
  "item.minecraft.warped_fungus_on_a_stick": "jamur kerukut di tongkat",
  "item.minecraft.nether_star": "bintang nether",
  "item.minecraft.pumpkin_pie": "kue labu",
  "item.minecraft.firework_rocket": "roket kembang api",
  "item.minecraft.firework_star": "bintang kembang api",
  "item.minecraft.enchanted_book": "buku pesona",
  "item.minecraft.nether_brick": "bata nether",
  "item.minecraft.quartz": "kuarsa nether",
  "item.minecraft.tnt_minecart": "kereta tambang dengan tnt",
  "item.minecraft.hopper_minecart": "kereta tambang bercorong",
  "item.minecraft.prismarine_shard": "serpihan prismarine",
  "item.minecraft.prismarine_crystals": "kristal prismarine",
  "item.minecraft.rabbit": "daging kelinci mentah",
  "item.minecraft.cooked_rabbit": "daging kelinci matang",
  "item.minecraft.rabbit_stew": "sup kelinci",
  "item.minecraft.rabbit_foot": "kaki kelinci",
  "item.minecraft.rabbit_hide": "kulit kelinci",
  "item.minecraft.armor_stand": "cagak zirah",
  "item.minecraft.iron_horse_armor": "zirah besi kuda",
  "item.minecraft.golden_horse_armor": "zirah kuda emas",
  "item.minecraft.diamond_horse_armor": "zirah berlian kuda",
  "item.minecraft.leather_horse_armor": "zirah kuda kulit",
  "item.minecraft.lead": "tali pengikat",
  "item.minecraft.name_tag": "label nama",
  "item.minecraft.command_block_minecart": "kereta tambang dengan blok perintah",
  "item.minecraft.mutton": "daging domba mentah",
  "item.minecraft.cooked_mutton": "daging domba matang",
  "block.minecraft.white_banner": "spanduk putih",
  "block.minecraft.orange_banner": "spanduk jingga",
  "block.minecraft.magenta_banner": "spanduk magenta",
  "block.minecraft.light_blue_banner": "spanduk biru muda",
  "block.minecraft.yellow_banner": "spanduk kuning",
  "block.minecraft.lime_banner": "spanduk limau",
  "block.minecraft.pink_banner": "spanduk merah jambu",
  "block.minecraft.gray_banner": "spanduk kelabu",
  "block.minecraft.light_gray_banner": "spanduk kelabu muda",
  "block.minecraft.cyan_banner": "spanduk sian",
  "block.minecraft.purple_banner": "spanduk ungu",
  "block.minecraft.blue_banner": "spanduk biru",
  "block.minecraft.brown_banner": "spanduk cokelat",
  "block.minecraft.green_banner": "spanduk hijau",
  "block.minecraft.red_banner": "spanduk merah",
  "block.minecraft.black_banner": "spanduk hitam",
  "item.minecraft.end_crystal": "kristal end",
  "item.minecraft.chorus_fruit": "buah korus",
  "item.minecraft.popped_chorus_fruit": "buah korus bakar",
  "item.minecraft.beetroot": "bit",
  "item.minecraft.beetroot_seeds": "biji akar bit",
  "item.minecraft.beetroot_soup": "sup akar bit",
  "item.minecraft.dragon_breath": "napas naga",
  "item.minecraft.splash_potion": "ramuan ciprat tak bisa dibuat□tanpa efek",
  "item.minecraft.spectral_arrow": "panah bersinar",
  "item.minecraft.tipped_arrow": "panah celup tak bisa dibuat□tanpa efek",
  "item.minecraft.lingering_potion": "ramuan jangkar tak bisa dibuat□tanpa efek",
  "item.minecraft.shield": "perisai",
  "item.minecraft.elytra": "sayap kumbang",
  "item.minecraft.spruce_boat": "perahu kayu cemara",
  "item.minecraft.birch_boat": "perahu kayu pinus",
  "item.minecraft.jungle_boat": "perahu kayu rimba",
  "item.minecraft.acacia_boat": "perahu kayu akasia",
  "item.minecraft.dark_oak_boat": "perahu kayu ek gelap",
  "item.minecraft.totem_of_undying": "azimat keabadian",
  "item.minecraft.shulker_shell": "cangkang periuk pengintai",
  "item.minecraft.iron_nugget": "bongkahan besi",
  "item.minecraft.knowledge_book": "buku pengetahuan",
  "item.minecraft.debug_stick": "batang awakutu",
  "item.minecraft.music_disc_13": "cakram musik□c418 - 13",
  "item.minecraft.music_disc_cat": "cakram musik□c418 - cat",
  "item.minecraft.music_disc_blocks": "cakram musik□c418 - blocks",
  "item.minecraft.music_disc_chirp": "cakram musik□c418 - chirp",
  "item.minecraft.music_disc_far": "cakram musik□c418 - far",
  "item.minecraft.music_disc_mall": "cakram musik□c418 - mall",
  "item.minecraft.music_disc_mellohi": "cakram musik□c418 - mellohi",
  "item.minecraft.music_disc_stal": "cakram musik□c418 - stal",
  "item.minecraft.music_disc_strad": "cakram musik□c418 - strad",
  "item.minecraft.music_disc_ward": "cakram musik□c418 - ward",
  "item.minecraft.music_disc_11": "cakram musik□c418 - 11",
  "item.minecraft.music_disc_wait": "cakram musik□c418 - wait",
  "item.minecraft.music_disc_pigstep": "cakram musik□lena raine - pigstep",
  "item.minecraft.trident": "trisula□□saat di tangan utama:□+8 kekuatan serangan□-2.9 kecepatan serangan",
  "item.minecraft.phantom_membrane": "selaput pari momok",
  "item.minecraft.nautilus_shell": "cangkang nautilus",
  "item.minecraft.heart_of_the_sea": "jantung lautan",
  "item.minecraft.crossbow": "busur silang",
  "item.minecraft.suspicious_stew": "sup sangsi",
  "block.minecraft.loom": "alat tenun",
  "item.minecraft.flower_banner_pattern": "pola spanduk□wajah bunga",
  "item.minecraft.creeper_banner_pattern": "pola spanduk□wajah creeper",
  "item.minecraft.skull_banner_pattern": "pola spanduk□wajah tengkorak",
  "item.minecraft.mojang_banner_pattern": "pola spanduk□wajah logo",
  "item.minecraft.globe_banner_pattern": "pola spanduk□bola dunia",
  "item.minecraft.piglin_banner_pattern": "pola spanduk□moncong",
  "block.minecraft.composter": "komposter",
  "block.minecraft.barrel": "tong",
  "block.minecraft.smoker": "pengasap",
  "block.minecraft.blast_furnace": "tungku ledak",
  "block.minecraft.cartography_table": "meja pemetaan",
  "block.minecraft.fletching_table": "meja panahan",
  "block.minecraft.grindstone": "gerinda",
  "block.minecraft.lectern": "podium",
  "block.minecraft.smithing_table": "meja tempa",
  "block.minecraft.stonecutter": "pemahat batu",
  "block.minecraft.bell": "lonceng",
  "block.minecraft.lantern": "lentera",
  "block.minecraft.soul_lantern": "lentera api roh",
  "item.minecraft.sweet_berries": "buni manis",
  "block.minecraft.campfire": "api unggun",
  "block.minecraft.soul_campfire": "api unggun jiwa",
  "block.minecraft.shroomlight": "lampu jamur",
  "item.minecraft.honeycomb": "sarang madu",
  "block.minecraft.bee_nest": "sarang lebah",
  "block.minecraft.beehive": "sarang lebah",
  "item.minecraft.honey_bottle": "botol madu",
  "block.minecraft.honey_block": "blok madu",
  "block.minecraft.honeycomb_block": "blok sarang madu",
  "block.minecraft.lodestone": "batu magnet",
  "block.minecraft.netherite_block": "blok neterit",
  "block.minecraft.ancient_debris": "puing purba",
  "block.minecraft.target": "sasaran",
  "block.minecraft.crying_obsidian": "obsidian menangis",
  "block.minecraft.blackstone": "batu hitam",
  "block.minecraft.blackstone_slab": "lempeng batu hitam",
  "block.minecraft.blackstone_stairs": "tangga batu hitam",
  "block.minecraft.gilded_blackstone": "batu hitam sepuh",
  "block.minecraft.polished_blackstone": "batu hitam poles",
  "block.minecraft.polished_blackstone_slab": "lempeng batu hitam poles",
  "block.minecraft.polished_blackstone_stairs": "tangga batu hitam poles",
  "block.minecraft.chiseled_polished_blackstone": "batu hitam poles pahatan",
  "block.minecraft.polished_blackstone_bricks": "bata batu hitam poles",
  "block.minecraft.polished_blackstone_brick_slab": "lempeng bata batu hitam poles",
  "block.minecraft.polished_blackstone_brick_stairs": "tangga bata batu hitam poles",
  "block.minecraft.cracked_polished_blackstone_bricks": "bata batu hitam poles retak",
  "block.minecraft.respawn_anchor": "jangkar pembangkit",
}
export const id_id = items; 
